import { ISiteRouter } from '@/ISiteRouter';
import Base from './Base.vue';

const links = [{
  name: "Galloway House Fibre Internet",
  shortlink: "GallowayHouseFibre",
  actLink: "xmP46H",
  type: 'form',
}, {
  name: "Glenashly Heights Fibre Internet",
  shortlink: "GlenashlyHeightsFibre",
  actLink: "vojdb6",
  type: 'form',
}, {
  name: "Glenwood Fibre Internet",
  shortlink: "GlenwoodFibre",
  actLink: "k2AcvJ",
  type: 'form',
}, {
  name: "Signup",
  shortlink: "Signup",
  actLink: "LTkx5W",
  type: 'form',
}, {
  name: "GhostFibreConnect",
  shortlink: "GhostFibreConnect",
  actLink: "k2AcvJ",
  type: 'form',
}, {
  name: "New PBX Setup",
  shortlink: "NewPBX",
  actLink: "zMIVfZ",
  type: 'form',
}, {
  name: "Marble Arch Fibre Internet",
  shortlink: "MarbleArchFibre",
  actLink: "zVUIHY",
  type: 'form',
}, {
  name: "Fibre Internet Signup",
  shortlink: "FibreSignup",
  actLink: "inz08T",
  type: 'form',
}, {
  name: "Phoenix Fibre Internet by BetterCorp",
  shortlink: "PhoenixFibre",
  actLink: "Ebd7CD",
  type: 'form',
}, {
  name: "Fibre Acceptance Documentation",
  shortlink: "FibreAcceptance",
  actLink: "TD0yx5",
  type: 'formSig',
}, {
  name: "VoIP Number Porting",
  shortlink: "VoIPPortingSession",
  actLink: "n6SItRfa",
  type: 'formSig',
}, {
  name: "BetterNetworks Router Manager",
  shortlink: "BetterNetworksRouterManager",
  actLink: "CT2jCFFT",
  type: 'formSig',
}, {
  name: "Facebook",
  shortlink: "Facebook",
  actLink: "https://facebook.com/BetterCorp",
  type: 'redirect',
}
];

const headerConfig = {
  colorClass: 'grey',
  foreground: '#FFFFFF',
  items: [
    {
      url: null,
      name: 'Go to main site',
    },
    {
      url: 'https://bettercorp.co.za',
      name: 'Go to main site',
    },
  ],
  logo: {
    url: '/img/betterCorp-Logo-White.svg',
    width: 150,
    height: 60,
  },
};
const thisHostname = 'start.bettercorp.co.za';

function generateFormUriComponent(shortlink: string, name: string, reallink: string, signatureForm: Boolean = false): any {
  return {
    path: `/${shortlink}${signatureForm ? '/Sign/:formId/:uid' : ''}`,
    name: name,
    component: () => signatureForm ? import('./FormSign') : import('./Form.vue'),
    meta: {
      signatureForm: signatureForm,
      typeFormLink: reallink,
      host: thisHostname,
      comingSoon: false,
      base: Base,
      headerConfig: {
        hideOnInitial: false,
        ...headerConfig,
      },
    },
  }
}
function generateRedirectUriComponent(shortlink: string, name: string, reallink: string): any {
  return {
    path: shortlink,
    name: name,
    component: () => {
      window.location.href = reallink;
    },
  }
}
function getListOfRoutes(): any[] {
  let listToReturn = [];
  for (let link of links) {
    if (link.type === 'redirect')
      listToReturn.push(generateRedirectUriComponent(`/${link.shortlink}`, link.name, link.actLink));
    else if (link.type === 'form')
      listToReturn.push(generateFormUriComponent(link.shortlink, link.name, link.actLink));
    else if (link.type === 'formSig') {
      listToReturn.push(generateFormUriComponent(link.shortlink, link.name, link.actLink, true));
      listToReturn.push(generateFormUriComponent(link.shortlink, link.name, link.actLink));
    }
  }
  listToReturn.push(generateRedirectUriComponent('*', 'Not Found', 'https://bettercorp.co.za/'));
  return listToReturn;
}

export default {
  config: {
    docBackgroundColour: '#333333',
    companyName: 'BetterCorp',
    companyThemeColour: 'rgb(0, 145, 234)',
    companyDescription: 'BetterCorp is a services company here to better your life.',
    companyKeywords: ['bettercorp', 'services', 'south africa', 'better', 'ninja', 'betterninja', 'betterweb', 'betterfibre'],
    companyIcons: {
      'Large': '/bcorp-icons/apple-icon.png',
      '192x192': '/bcorp-icons/android-icon-192x192.png',
      '76x76': '/bcorp-icons/apple-icon-76x76.png',
      '120x120': '/bcorp-icons/apple-icon-120x120.png',
      '152x152': '/bcorp-icons/apple-icon-152x152.png',
      '310x310': '/bcorp-icons/ms-icon-310x310.png',
      '70x70': '/bcorp-icons/ms-icon-70x70.png',
      '150x150': '/bcorp-icons/ms-icon-150x150.png',
    },
  },
  routes: getListOfRoutes()
} as ISiteRouter;
